import { ListSearchItem } from '@/types/YuukyuuKanri'
import { defineStore } from 'pinia'
import { Permission, Role } from '@/types/Permissions'

export const useYuukyuuKanriStore = defineStore('YuukyuuKanri', {
  state: () => {
    return {
      item: {
        searchDiv: 1,
        syuugyouBasyoId: null
      } as ListSearchItem,
    }
  },
  actions: {
    // 検索条件のセット
    setItem(searchItem: ListSearchItem) {
      this.item = searchItem
    },
    // 検索条件のクリア
    removeItem() {
      this.item = {
        searchDiv: 1,
        syuugyouBasyoId: null
      };
    }
  },
  getters: {
    searchItem(): ListSearchItem {
      return this.item
    },
  }
})
